import { API } from "aws-amplify";
import { updateUser } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { EMPTY_USER_INFO } from "./getUserInfo";

export const editUserInfo = async (
  payload: APITypes.UpdateUserInput
): Promise<LoaderData<APITypes.User>> => {
  try {
    const response = (await API.graphql({
      query: updateUser,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateUserMutation };

    return {
      success: true,
      data: response.data?.updateUser || EMPTY_USER_INFO,
    };
  } catch (error) {
    console.error("Edit user info error", error);

    return {
      success: false,
      data: EMPTY_USER_INFO,
      error,
    };
  }
};
